/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  UpgradeTest,
  UpgradeTestInterface,
} from "../../../../contracts/test/upgradeTest.sol/UpgradeTest";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isUpgraded",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marketMakerBalance",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marketMakerVault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "users",
    outputs: [
      {
        internalType: "uint128",
        name: "totalDeposit",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "totalWithdraw",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawLimitFillDay",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawLimitLastFill",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawLimitLeft",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "0x60a06040523060805234801561001457600080fd5b50608051611dcb61004c600039600081816106ad0152818161075d015281816108b2015281816109620152610aa70152611dcb6000f3fe6080604052600436106101295760003560e01c806376ec3b7d116100a5578063a217fddf11610074578063ac9650d811610059578063ac9650d814610490578063c355ebed146104bd578063d547741f146104fb57600080fd5b8063a217fddf146103fa578063a87430ba1461040f57600080fd5b806376ec3b7d146102f45780638fec412f1461033f57806391d148541461037d5780639711ce14146103d057600080fd5b80633659cfe6116100fc5780634f1ef286116100e15780634f1ef286146102795780634f8eccd91461028c57806352d1902d146102df57600080fd5b80633659cfe6146101e357806342c80fc91461020357600080fd5b806301ffc9a71461012e578063248a9ca3146101635780632f2ff15d146101a157806336568abe146101c3575b600080fd5b34801561013a57600080fd5b5061014e6101493660046117e5565b61051b565b60405190151581526020015b60405180910390f35b34801561016f57600080fd5b5061019361017e366004611827565b600090815260fd602052604090206001015490565b60405190815260200161015a565b3480156101ad57600080fd5b506101c16101bc366004611869565b6105b4565b005b3480156101cf57600080fd5b506101c16101de366004611869565b6105de565b3480156101ef57600080fd5b506101c16101fe366004611895565b610696565b34801561020f57600080fd5b5061013154604080518082018252600881527f55706772616465640000000000000000000000000000000000000000000000006020820152905161015a9270010000000000000000000000000000000090046fffffffffffffffffffffffffffffffff169061191e565b6101c161028736600461196f565b61089b565b34801561029857600080fd5b50610132546102ba9073ffffffffffffffffffffffffffffffffffffffff1681565b60405173ffffffffffffffffffffffffffffffffffffffff909116815260200161015a565b3480156102eb57600080fd5b50610193610a8d565b34801561030057600080fd5b506101305461031e906fffffffffffffffffffffffffffffffff1681565b6040516fffffffffffffffffffffffffffffffff909116815260200161015a565b34801561034b57600080fd5b506101315461031e9070010000000000000000000000000000000090046fffffffffffffffffffffffffffffffff1681565b34801561038957600080fd5b5061014e610398366004611869565b600091825260fd6020908152604080842073ffffffffffffffffffffffffffffffffffffffff93909316845291905290205460ff1690565b3480156103dc57600080fd5b506101315461031e906fffffffffffffffffffffffffffffffff1681565b34801561040657600080fd5b50610193600081565b34801561041b57600080fd5b5061046761042a366004611895565b61012f602052600090815260409020546fffffffffffffffffffffffffffffffff8082169170010000000000000000000000000000000090041682565b604080516fffffffffffffffffffffffffffffffff93841681529290911660208301520161015a565b34801561049c57600080fd5b506104b06104ab366004611a4f565b610b79565b60405161015a9190611ac4565b3480156104c957600080fd5b506101305461031e9070010000000000000000000000000000000090046fffffffffffffffffffffffffffffffff1681565b34801561050757600080fd5b506101c1610516366004611869565b610c6e565b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f7965db0b0000000000000000000000000000000000000000000000000000000014806105ae57507f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b92915050565b600082815260fd60205260409020600101546105cf81610c93565b6105d98383610c9d565b505050565b73ffffffffffffffffffffffffffffffffffffffff81163314610688576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602f60248201527f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560448201527f20726f6c657320666f722073656c66000000000000000000000000000000000060648201526084015b60405180910390fd5b6106928282610d91565b5050565b73ffffffffffffffffffffffffffffffffffffffff7f000000000000000000000000000000000000000000000000000000000000000016300361075b576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602c60248201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060448201527f64656c656761746563616c6c0000000000000000000000000000000000000000606482015260840161067f565b7f000000000000000000000000000000000000000000000000000000000000000073ffffffffffffffffffffffffffffffffffffffff166107d07f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5473ffffffffffffffffffffffffffffffffffffffff1690565b73ffffffffffffffffffffffffffffffffffffffff1614610873576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602c60248201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060448201527f6163746976652070726f78790000000000000000000000000000000000000000606482015260840161067f565b61087c81610e4c565b6040805160008082526020820190925261089891839190610e57565b50565b73ffffffffffffffffffffffffffffffffffffffff7f0000000000000000000000000000000000000000000000000000000000000000163003610960576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602c60248201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060448201527f64656c656761746563616c6c0000000000000000000000000000000000000000606482015260840161067f565b7f000000000000000000000000000000000000000000000000000000000000000073ffffffffffffffffffffffffffffffffffffffff166109d57f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5473ffffffffffffffffffffffffffffffffffffffff1690565b73ffffffffffffffffffffffffffffffffffffffff1614610a78576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602c60248201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060448201527f6163746976652070726f78790000000000000000000000000000000000000000606482015260840161067f565b610a8182610e4c565b61069282826001610e57565b60003073ffffffffffffffffffffffffffffffffffffffff7f00000000000000000000000000000000000000000000000000000000000000001614610b54576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152603860248201527f555550535570677261646561626c653a206d757374206e6f742062652063616c60448201527f6c6564207468726f7567682064656c656761746563616c6c0000000000000000606482015260840161067f565b507f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc90565b60608167ffffffffffffffff811115610b9457610b94611940565b604051908082528060200260200182016040528015610bc757816020015b6060815260200190600190039081610bb25790505b50905060005b82811015610c6757610c3730858584818110610beb57610beb611b44565b9050602002810190610bfd9190611b73565b8080601f01602080910402602001604051908101604052809392919081815260200183838082843760009201919091525061105692505050565b828281518110610c4957610c49611b44565b60200260200101819052508080610c5f90611c0e565b915050610bcd565b5092915050565b600082815260fd6020526040902060010154610c8981610c93565b6105d98383610d91565b6108988133611082565b600082815260fd6020908152604080832073ffffffffffffffffffffffffffffffffffffffff8516845290915290205460ff1661069257600082815260fd6020908152604080832073ffffffffffffffffffffffffffffffffffffffff85168452909152902080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00166001179055610d333390565b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b600082815260fd6020908152604080832073ffffffffffffffffffffffffffffffffffffffff8516845290915290205460ff161561069257600082815260fd6020908152604080832073ffffffffffffffffffffffffffffffffffffffff8516808552925280832080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0016905551339285917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a45050565b600061069281610c93565b7f4910fdfa16fed3260ed0e7147f7cc6da11a60208b5b9406d12a635614ffd91435460ff1615610e8a576105d98361113c565b8273ffffffffffffffffffffffffffffffffffffffff166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015610f0f575060408051601f3d9081017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0168201909252610f0c91810190611c46565b60015b610f9b576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602e60248201527f45524331393637557067726164653a206e657720696d706c656d656e7461746960448201527f6f6e206973206e6f742055555053000000000000000000000000000000000000606482015260840161067f565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc811461104a576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602960248201527f45524331393637557067726164653a20756e737570706f727465642070726f7860448201527f6961626c65555549440000000000000000000000000000000000000000000000606482015260840161067f565b506105d9838383611246565b606061107b8383604051806060016040528060278152602001611d6f60279139611271565b9392505050565b600082815260fd6020908152604080832073ffffffffffffffffffffffffffffffffffffffff8516845290915290205460ff16610692576110c2816112f6565b6110cd836020611315565b6040516020016110de929190611c5f565b604080517fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0818403018152908290527f08c379a000000000000000000000000000000000000000000000000000000000825261067f91600401611ce0565b73ffffffffffffffffffffffffffffffffffffffff81163b6111e0576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602d60248201527f455243313936373a206e657720696d706c656d656e746174696f6e206973206e60448201527f6f74206120636f6e747261637400000000000000000000000000000000000000606482015260840161067f565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc80547fffffffffffffffffffffffff00000000000000000000000000000000000000001673ffffffffffffffffffffffffffffffffffffffff92909216919091179055565b61124f83611558565b60008251118061125c5750805b156105d95761126b83836115a5565b50505050565b60606000808573ffffffffffffffffffffffffffffffffffffffff168560405161129b9190611cf3565b600060405180830381855af49150503d80600081146112d6576040519150601f19603f3d011682016040523d82523d6000602084013e6112db565b606091505b50915091506112ec868383876116e4565b9695505050505050565b60606105ae73ffffffffffffffffffffffffffffffffffffffff831660145b60606000611324836002611d0f565b61132f906002611d26565b67ffffffffffffffff81111561134757611347611940565b6040519080825280601f01601f191660200182016040528015611371576020820181803683370190505b5090507f3000000000000000000000000000000000000000000000000000000000000000816000815181106113a8576113a8611b44565b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a9053507f78000000000000000000000000000000000000000000000000000000000000008160018151811061140b5761140b611b44565b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a9053506000611447846002611d0f565b611452906001611d26565b90505b60018111156114ef577f303132333435363738396162636465660000000000000000000000000000000085600f166010811061149357611493611b44565b1a60f81b8282815181106114a9576114a9611b44565b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a90535060049490941c936114e881611d39565b9050611455565b50831561107b576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e74604482015260640161067f565b6115618161113c565b60405173ffffffffffffffffffffffffffffffffffffffff8216907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a250565b606073ffffffffffffffffffffffffffffffffffffffff83163b61164b576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602660248201527f416464726573733a2064656c65676174652063616c6c20746f206e6f6e2d636f60448201527f6e74726163740000000000000000000000000000000000000000000000000000606482015260840161067f565b6000808473ffffffffffffffffffffffffffffffffffffffff16846040516116739190611cf3565b600060405180830381855af49150503d80600081146116ae576040519150601f19603f3d011682016040523d82523d6000602084013e6116b3565b606091505b50915091506116db8282604051806060016040528060278152602001611d6f6027913961178c565b95945050505050565b6060831561177a5782516000036117735773ffffffffffffffffffffffffffffffffffffffff85163b611773576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e7472616374000000604482015260640161067f565b5081611784565b61178483836117a1565b949350505050565b6060831561179b57508161107b565b61107b83835b8151156117b15781518083602001fd5b806040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161067f9190611ce0565b6000602082840312156117f757600080fd5b81357fffffffff000000000000000000000000000000000000000000000000000000008116811461107b57600080fd5b60006020828403121561183957600080fd5b5035919050565b803573ffffffffffffffffffffffffffffffffffffffff8116811461186457600080fd5b919050565b6000806040838503121561187c57600080fd5b8235915061188c60208401611840565b90509250929050565b6000602082840312156118a757600080fd5b61107b82611840565b60005b838110156118cb5781810151838201526020016118b3565b50506000910152565b600081518084526118ec8160208601602086016118b0565b601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0169290920160200192915050565b60408152600061193160408301856118d4565b90508260208301529392505050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6000806040838503121561198257600080fd5b61198b83611840565b9150602083013567ffffffffffffffff808211156119a857600080fd5b818501915085601f8301126119bc57600080fd5b8135818111156119ce576119ce611940565b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0908116603f01168101908382118183101715611a1457611a14611940565b81604052828152886020848701011115611a2d57600080fd5b8260208601602083013760006020848301015280955050505050509250929050565b60008060208385031215611a6257600080fd5b823567ffffffffffffffff80821115611a7a57600080fd5b818501915085601f830112611a8e57600080fd5b813581811115611a9d57600080fd5b8660208260051b8501011115611ab257600080fd5b60209290920196919550909350505050565b6000602080830181845280855180835260408601915060408160051b870101925083870160005b82811015611b37577fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc0888603018452611b258583516118d4565b94509285019290850190600101611aeb565b5092979650505050505050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b60008083357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe1843603018112611ba857600080fd5b83018035915067ffffffffffffffff821115611bc357600080fd5b602001915036819003821315611bd857600080fd5b9250929050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8203611c3f57611c3f611bdf565b5060010190565b600060208284031215611c5857600080fd5b5051919050565b7f416363657373436f6e74726f6c3a206163636f756e7420000000000000000000815260008351611c978160178501602088016118b0565b7f206973206d697373696e6720726f6c65200000000000000000000000000000006017918401918201528351611cd48160288401602088016118b0565b01602801949350505050565b60208152600061107b60208301846118d4565b60008251611d058184602087016118b0565b9190910192915050565b80820281158282048414176105ae576105ae611bdf565b808201808211156105ae576105ae611bdf565b600081611d4857611d48611bdf565b507fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff019056fe416464726573733a206c6f772d6c6576656c2064656c65676174652063616c6c206661696c6564a26469706673582212204b4a02abaccfeb74adc31ab77bf671b7ddd1a75e1f9f1a96a152ebc658ed38fd64736f6c63430008110033";

type UpgradeTestConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UpgradeTestConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UpgradeTest__factory extends ContractFactory {
  constructor(...args: UpgradeTestConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<UpgradeTest> {
    return super.deploy(overrides || {}) as Promise<UpgradeTest>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): UpgradeTest {
    return super.attach(address) as UpgradeTest;
  }
  override connect(signer: Signer): UpgradeTest__factory {
    return super.connect(signer) as UpgradeTest__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UpgradeTestInterface {
    return new utils.Interface(_abi) as UpgradeTestInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UpgradeTest {
    return new Contract(address, _abi, signerOrProvider) as UpgradeTest;
  }
}
